import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

/**
 * Full-page add/edit shell (same pattern as Students add/edit routes).
 */
const FormPageLayout = ({ backTo, backLabel, children }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3 }}
    className="space-y-6"
  >
    <div>
      <Link
        to={backTo}
        className="inline-flex items-center text-sm font-medium text-slate-600 transition-colors hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-50"
      >
        <ArrowLeftIcon className="h-5 w-5 ltr:mr-2 rtl:ml-2" />
        {backLabel}
      </Link>
    </div>
    {children}
  </motion.div>
);

export default FormPageLayout;
